import React from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import MotorSelect from "./MotorSelect";
import { MotorContact, MotorVehicleType, MotorMakeModel } from "./MotorShared";

const ThirdParty = ({ user, setUser, details, setDetails }) => {
  const update = (key) => (event) => setDetails((previous) => ({ ...previous, [key]: event.target.value }));
  return (
    <div>
      <MotorContact user={user} setUser={setUser} />
      <MotorVehicleType details={details} setDetails={setDetails} />
      <MotorSelect name="third-usage" label="Usage" value={details.purpose_of_use}
        onChange={(value) => setDetails((previous) => ({ ...previous, purpose_of_use: value }))}
        options={["Private", "Hiring"]} />
      <MotorMakeModel details={details} setDetails={setDetails} />
      {[["registration_number", "Vehicle registration number"],
        ["engine_number", "Engine number"], ["chassis_number", "Chassis number"]]
        .map(([field, label]) => (
          <FloatingLabel key={field} controlId={`motor-${field}`} label={`${label}*`}>
            <Form.Control type="text" required placeholder={`${label}*`}
              value={details[field]} onChange={update(field)} />
          </FloatingLabel>
        ))}
    </div>
  );
};

export default ThirdParty;
